export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var p={
    businessId:$params.businessId,
    batchId:$params.batchId,
    draftsDocId:$params.draftsDocId,
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId
  }
  if($params.extParams && $params.extParams.fullAuthType){
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowWorktrackTree", p, function(res){

  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-worktracktree.js